// Slow editorial marquee band.
export const Marquee = () => {
  const words = ["Carpets", "Rugs", "Upholstery", "Stain Removal", "Fresh Results"];
  const items = [...words, ...words, ...words];
  return (
    <section
      data-testid="marquee-band"
      className="relative overflow-hidden bg-navy py-6 sm:py-8"
    >
      <div className="marquee-mask">
        <div className="marquee-track-slow flex w-max items-center gap-8 whitespace-nowrap">
          {items.map((w, i) => (
            <span key={i} className="flex items-center gap-8">
              <span className="font-display italic text-2xl sm:text-4xl text-white/90">
                {w}
              </span>
              <span className="h-2.5 w-2.5 rounded-full bg-turquoise" />
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};
